<section class="app-empty-state__container">
  <section class="app-empty-state__container__image">
    <svg *ngIf="!filterEmpty"
         data-name="Empty States"
         id="edb6a6d0-faa2-4fec-821a-58566ecfcd6d"
         viewBox="0 0 1200 600"
         xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <style>
          .f431e571-402d-4f46-b048-b36645ca396d {
            fill: none;
          }

          .ea43ba0a-5518-410d-8820-3fff39ae58c6 {
            fill: #c1d0db;
          }

          .b4ea40ce-cb3c-4987-86b4-1ade44dcf07b {
            fill: #e1ecf2;
          }

          .a37d6eef-f0c2-4220-86fe-f44f260b91e7 {
            fill: #96a3ab;
          }

          .b2af2322-822b-437a-bb6b-89a0befcb0da {
            fill: #a7b1b8;
          }
        </style>
      </defs>
      <g
        data-name="Contorneado_Examenes"
        id="a4d5a07f-8d8a-4713-accf-7d32ee30f4b9"
      >
        <rect
          class="f431e571-402d-4f46-b048-b36645ca396d"
          height="600"
          width="1200"
        />
        <path
          class="ea43ba0a-5518-410d-8820-3fff39ae58c6"
          d="M1183.29,567.51H16.71a5,5,0,0,1,0-10H1183.29a5,5,0,0,1,0,10Z"
        />
        <path
          class="b4ea40ce-cb3c-4987-86b4-1ade44dcf07b"
          d="M797.61,50.58a5.31,5.31,0,0,1-1-.09,5.11,5.11,0,0,1-.94-.29,4.74,4.74,0,0,1-.86-.46,5,5,0,0,1-.76-.62,4.57,4.57,0,0,1-.62-.76,4.74,4.74,0,0,1-.46-.86,5.11,5.11,0,0,1-.29-.94,5.33,5.33,0,0,1,0-2,5.11,5.11,0,0,1,.29-.94,4.74,4.74,0,0,1,.46-.86,5,5,0,0,1,.62-.76,4.57,4.57,0,0,1,.76-.62,4.74,4.74,0,0,1,.86-.46,5.11,5.11,0,0,1,.94-.29,4.92,4.92,0,0,1,2,0,5.11,5.11,0,0,1,.94.29,4.74,4.74,0,0,1,.86.46,4.86,4.86,0,0,1,1.38,1.38,4.74,4.74,0,0,1,.46.86,5.11,5.11,0,0,1,.29.94,5.33,5.33,0,0,1,0,2,5.11,5.11,0,0,1-.29.94,4.74,4.74,0,0,1-.46.86,4.57,4.57,0,0,1-.62.76,5,5,0,0,1-.76.62,4.74,4.74,0,0,1-.86.46,5.11,5.11,0,0,1-.94.29A5.33,5.33,0,0,1,797.61,50.58Z"
        />
        <path
          class="b4ea40ce-cb3c-4987-86b4-1ade44dcf07b"
          d="M768.52,50.59H680a5,5,0,0,1,0-10h88.52a5,5,0,0,1,0,10Z"
        />
        <path
          class="b4ea40ce-cb3c-4987-86b4-1ade44dcf07b"
          d="M300.16,296.64h-69a5,5,0,0,1,0-10h69a5,5,0,0,1,0,10Z"
        />
        <path
          class="b4ea40ce-cb3c-4987-86b4-1ade44dcf07b"
          d="M465.51,79.83H440.17a5,5,0,0,1,0-10h25.34a5,5,0,0,1,0,10Z"
        />
        <path
          class="b4ea40ce-cb3c-4987-86b4-1ade44dcf07b"
          d="M293.41,513.59H221.83a5,5,0,1,1,0-10h71.58a5,5,0,0,1,0,10Z"
        />
        <path
          class="b4ea40ce-cb3c-4987-86b4-1ade44dcf07b"
          d="M348.42,154.91H289.7a5,5,0,0,1,0-10h58.72a5,5,0,0,1,0,10Z"
        />
        <path
          class="b4ea40ce-cb3c-4987-86b4-1ade44dcf07b"
          d="M888.31,419.65h-97a5,5,0,0,1,0-10h97a5,5,0,0,1,0,10Z"
        />
        <path
          class="b4ea40ce-cb3c-4987-86b4-1ade44dcf07b"
          d="M911.13,443H862.62a5,5,0,0,1,0-10h48.51a5,5,0,0,1,0,10Z"
        />
        <path
          class="b4ea40ce-cb3c-4987-86b4-1ade44dcf07b"
          d="M869.86,469.78H821.35a5,5,0,0,1,0-10h48.51a5,5,0,0,1,0,10Z"
        />
        <path
          class="b4ea40ce-cb3c-4987-86b4-1ade44dcf07b"
          d="M897.29,108.27h-71a5,5,0,0,1,0-10h71a5,5,0,0,1,0,10Z"
        />
        <path
          class="b4ea40ce-cb3c-4987-86b4-1ade44dcf07b"
          d="M205.43,296.64H204a5,5,0,0,1,0-10h1.43a5,5,0,0,1,0,10Z"
        />
        <path
          class="b4ea40ce-cb3c-4987-86b4-1ade44dcf07b"
          d="M237.79,360.49H97a5,5,0,0,1,0-10h140.8a5,5,0,0,1,0,10Z"
        />
        <path
          class="b4ea40ce-cb3c-4987-86b4-1ade44dcf07b"
          d="M295.57,446.43h-1.43a5,5,0,0,1,0-10h1.43a5,5,0,0,1,0,10Z"
        />
        <path
          class="b4ea40ce-cb3c-4987-86b4-1ade44dcf07b"
          d="M254.9,417.08H236.36a5,5,0,0,1,0-10H254.9a5,5,0,0,1,0,10Z"
        />
        <path
          class="b4ea40ce-cb3c-4987-86b4-1ade44dcf07b"
          d="M300.16,247.7H160.36a5,5,0,0,1,0-10h139.8a5,5,0,0,1,0,10Z"
        />
        <path
          class="b4ea40ce-cb3c-4987-86b4-1ade44dcf07b"
          d="M978.88,205.3H792.76a5,5,0,0,1,0-10H978.88a5,5,0,0,1,0,10Z"
        />
        <path
          class="b4ea40ce-cb3c-4987-86b4-1ade44dcf07b"
          d="M832.07,513.59a5,5,0,0,1-1.92-.39,4.74,4.74,0,0,1-.86-.46,5,5,0,0,1-2.22-4.16,5.31,5.31,0,0,1,.09-1,5.11,5.11,0,0,1,.29-.94,4.74,4.74,0,0,1,.46-.86,4.86,4.86,0,0,1,1.38-1.38,4.74,4.74,0,0,1,.86-.46,5.36,5.36,0,0,1,.94-.29,4.92,4.92,0,0,1,1.95,0,5.11,5.11,0,0,1,.94.29,4.74,4.74,0,0,1,.86.46,4.86,4.86,0,0,1,1.38,1.38,4.74,4.74,0,0,1,.46.86,5.11,5.11,0,0,1,.29.94,5.33,5.33,0,0,1,0,1.95,5.11,5.11,0,0,1-.29.94,4.74,4.74,0,0,1-.46.86,4.57,4.57,0,0,1-.62.76,5,5,0,0,1-.76.62,4.74,4.74,0,0,1-.86.46,5.11,5.11,0,0,1-.94.29A5.32,5.32,0,0,1,832.07,513.59Z"
        />
        <path
          class="b4ea40ce-cb3c-4987-86b4-1ade44dcf07b"
          d="M811.41,513.58H707.51a5,5,0,1,1,0-10h103.9a5,5,0,0,1,0,10Z"
        />
        <path
          class="a37d6eef-f0c2-4220-86fe-f44f260b91e7"
          d="M335.15,122.51a43.32,43.32,0,0,1-8.86-85.7A9,9,0,0,1,336.8,48.53a30.7,30.7,0,0,0,27.48,40.64,9,9,0,0,1,7.11,14A43.39,43.39,0,0,1,335.15,122.51ZM317.2,61.44a25.33,25.33,0,0,0,27.86,41.12A48.8,48.8,0,0,1,317.2,61.44Z"
        />
        <path
          class="b2af2322-822b-437a-bb6b-89a0befcb0da"
          d="M767.07,380.94v30.92a30.82,30.82,0,0,1-30.79,30.78H685v-16h51.3a14.8,14.8,0,0,0,14.79-14.78V380.48"
        />
        <path
          class="b2af2322-822b-437a-bb6b-89a0befcb0da"
          d="M751.07,290.37V91.6a14.8,14.8,0,0,0-14.79-14.78H532.22A14.8,14.8,0,0,0,517.43,91.6v12h-16v-12a30.82,30.82,0,0,1,30.79-30.78H736.28A30.82,30.82,0,0,1,767.07,91.6v196"
        />
        <path
          class="a37d6eef-f0c2-4220-86fe-f44f260b91e7"
          d="M610.81,528.71h-13a4,4,0,0,1,0-8h9V503.57a4,4,0,1,1,8,0v21.14A4,4,0,0,1,610.81,528.71Z"
        />
        <path
          class="a37d6eef-f0c2-4220-86fe-f44f260b91e7"
          d="M572.64,528.71H547.47a4,4,0,0,1,0-8h25.17a4,4,0,0,1,0,8Zm-50.34,0H497.14a4,4,0,0,1,0-8H522.3a4,4,0,0,1,0,8Zm-50.33,0H446.8a4,4,0,1,1,0-8H472a4,4,0,0,1,0,8Zm-50.34,0H396.46a4,4,0,0,1,0-8h25.17a4,4,0,0,1,0,8Zm-50.34,0h-9.18a24.87,24.87,0,0,1-17.24-6.89,4,4,0,1,1,5.52-5.79,16.91,16.91,0,0,0,11.72,4.68h9.18a4,4,0,0,1,0,8ZM341.1,499.57a4,4,0,0,1-4-4V470.4a4,4,0,0,1,8,0v25.17A4,4,0,0,1,341.1,499.57Zm0-50.34a4,4,0,0,1-4-4V420.06a4,4,0,0,1,8,0v25.17A4,4,0,0,1,341.1,449.23Zm0-50.34a4,4,0,0,1-4-4V369.72a4,4,0,0,1,8,0v25.17A4,4,0,0,1,341.1,398.89Zm0-50.34a4,4,0,0,1-4-4V319.39a4,4,0,0,1,8,0v25.16A4,4,0,0,1,341.1,348.55Zm0-50.33a4,4,0,0,1-4-4V269.05a4,4,0,0,1,8,0v25.17A4,4,0,0,1,341.1,298.22Zm0-50.34a4,4,0,0,1-4-4V218.71a4,4,0,0,1,8,0v25.17A4,4,0,0,1,341.1,247.88Z"
        />
        <path
          class="a37d6eef-f0c2-4220-86fe-f44f260b91e7"
          d="M341.1,197.52a4,4,0,0,1-4-4v-13a4,4,0,0,1,4-4h19.69a4,4,0,0,1,0,8H345.1v9A4,4,0,0,1,341.1,197.52Z"
        />
        <path
          class="b4ea40ce-cb3c-4987-86b4-1ade44dcf07b"
          d="M657.88,495.88H398.61a31.82,31.82,0,0,1-31.78-31.79v-322a31.82,31.82,0,0,1,31.78-31.78h71.56v18H398.61a13.79,13.79,0,0,0-13.78,13.78v322a13.8,13.8,0,0,0,13.78,13.79H657.88a13.8,13.8,0,0,0,13.78-13.79v-322a13.79,13.79,0,0,0-13.78-13.78H586.32v-18h71.56a31.82,31.82,0,0,1,31.78,31.78v322A31.82,31.82,0,0,1,657.88,495.88Z"
        />
        <path
          class="ea43ba0a-5518-410d-8820-3fff39ae58c6"
          d="M586.32,114.74v-7.68A20.3,20.3,0,0,0,566,86.79h-75.6a20.29,20.29,0,0,0-20.27,20.27v8a27.72,27.72,0,0,0,10.67,53.41h95.5a27.72,27.72,0,0,0,10-53.68Zm-98.15-7.68a2.27,2.27,0,0,1,2.27-2.27H566a2.28,2.28,0,0,1,2.28,2.27v5.84H488.17Zm88.17,43.36h-95.5a9.76,9.76,0,1,1,0-19.52h95.5a9.76,9.76,0,1,1,0,19.52Z"
        />
        <path
          class="a37d6eef-f0c2-4220-86fe-f44f260b91e7"
          d="M491.48,356.67a9.45,9.45,0,0,1-2.94,7,9.81,9.81,0,0,1-6.92,2.75H442.74a13.26,13.26,0,0,1-8.37-2.69,10.26,10.26,0,0,1-4-8.41,12.09,12.09,0,0,1,3.13-8.1l29.37-33.75H441.25a9.63,9.63,0,0,1-9.74-9.74,9.79,9.79,0,0,1,2.75-6.91,9.46,9.46,0,0,1,7-2.95H479a11.64,11.64,0,0,1,8.42,3.31,11.47,11.47,0,0,1,3.31,8.3A12,12,0,0,1,488,313.3l-28.61,33.51h22.27a9.83,9.83,0,0,1,9.86,9.86Z"
        />
        <path
          class="a37d6eef-f0c2-4220-86fe-f44f260b91e7"
          d="M570.35,356.67a9.46,9.46,0,0,1-2.93,7,9.81,9.81,0,0,1-6.92,2.75H505.05a11.88,11.88,0,0,1-9.25-19.14l46.16-57H503.43a9.82,9.82,0,0,1-9.86-9.86,9.89,9.89,0,0,1,2.81-7,9.59,9.59,0,0,1,7.05-3h54.08a11.67,11.67,0,0,1,8.86,3.7,12.38,12.38,0,0,1,3.24,8.52,11.55,11.55,0,0,1-.9,4.33,13,13,0,0,1-2.15,3.55l-45.49,56.28H560.5a9.82,9.82,0,0,1,9.85,9.86Z"
        />
        <path
          class="a37d6eef-f0c2-4220-86fe-f44f260b91e7"
          d="M633,356.67a9.45,9.45,0,0,1-2.94,7,9.81,9.81,0,0,1-6.92,2.75H584.29a13.26,13.26,0,0,1-8.37-2.69,10.26,10.26,0,0,1-4-8.41,12.09,12.09,0,0,1,3.13-8.1l29.37-33.75H582.8a9.61,9.61,0,0,1-9.73-9.74,9.78,9.78,0,0,1,2.74-6.91,9.46,9.46,0,0,1,7-2.95h37.76a11.63,11.63,0,0,1,8.41,3.31,11.47,11.47,0,0,1,3.31,8.3,12,12,0,0,1-2.77,7.84L600.9,346.81h22.27a9.83,9.83,0,0,1,9.86,9.86Z"
        />
        <path
          class="a37d6eef-f0c2-4220-86fe-f44f260b91e7"
          d="M865.38,388.38H731a19.79,19.79,0,0,1-13.06-4.92l-3-2.67A8.33,8.33,0,0,1,714,380a44.87,44.87,0,0,1-10.72-23.48l-.14-1.05a8.25,8.25,0,0,1-.09-1.22A35.66,35.66,0,0,1,725,321.1a50.66,50.66,0,0,1,59.28-39.75,55.25,55.25,0,0,1,98.06,25.94,42.11,42.11,0,0,1,25.92,38.38,41.48,41.48,0,0,1-12.16,29.83A43.38,43.38,0,0,1,865.38,388.38ZM727.21,367.67l2.57,2.26a1.82,1.82,0,0,0,1.2.45h134.4a25.29,25.29,0,0,0,17.86-7.52,23.62,23.62,0,0,0,7-17,24.13,24.13,0,0,0-18.48-23.17,9,9,0,0,1-6.88-8.43v0a37.23,37.23,0,0,0-69.12-18,9,9,0,0,1-10.49,3.91l-.16,0a32.32,32.32,0,0,0-10.49-1.73,32.74,32.74,0,0,0-32.54,30.17,9,9,0,0,1-6.94,8.1l-.16,0a17.73,17.73,0,0,0-13.87,16.9l0,.37A26.91,26.91,0,0,0,727.21,367.67Z"
        />
      </g>
    </svg>
    <svg *ngIf="filterEmpty" viewBox="0 0 1200 600" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <style>.a3468cdb-f34a-4dae-986f-f07adfa1dd9a {
          opacity: 0.5;
        }

        .a6d513f0-514b-4b61-8726-b21c3739a351 {
          fill: none;
        }

        .a01e890d-37e4-4ddc-a93a-ca36d0e1d8c1 {
          fill: #c1d0db;
        }

        .eb04f35d-97df-4bf3-837a-6350c5a8af27 {
          fill: #e1ecf2;
        }

        .af60313a-2991-4142-84cb-e9f5a8c77182 {
          fill: #96a3ab;
        }

        .b8d212c2-8d6e-405d-9422-c9498cb7fe79 {
          fill: #a7b1b8;
        }

        .a9c882c5-5479-407f-8cba-3d90acfc6416 {
          fill: #fff;
        }</style>
      </defs>
      <g data-name="Capa 1" id="af384ec2-e3d6-4f56-b61f-5e4a1b35e353">
        <g data-name="SVG" id="a9d3c4bb-a226-401c-9ee9-519399843a60">
          <rect class="a6d513f0-514b-4b61-8726-b21c3739a351" height="600" width="1200"/>
          <path class="a01e890d-37e4-4ddc-a93a-ca36d0e1d8c1"
                d="M1183.29,567.51H16.71a5,5,0,0,1,0-10H1183.29a5,5,0,0,1,0,10Z"/>
          <path class="eb04f35d-97df-4bf3-837a-6350c5a8af27"
                d="M982.88,142.69a5.5,5.5,0,0,1-1-.09,5.26,5.26,0,0,1-.93-.29,4.74,4.74,0,0,1-.86-.46,4.57,4.57,0,0,1-.76-.62,5,5,0,0,1-.62-.76,4.19,4.19,0,0,1-.46-.86,4.9,4.9,0,0,1-.29-2.9,5.22,5.22,0,0,1,.28-.93,5.46,5.46,0,0,1,.46-.86,4.63,4.63,0,0,1,.63-.76,4.57,4.57,0,0,1,.76-.62,5.51,5.51,0,0,1,.86-.47,5.22,5.22,0,0,1,.93-.28,5,5,0,0,1,2.89.28,5.18,5.18,0,0,1,.87.47,5,5,0,0,1,.76.62,4.57,4.57,0,0,1,.62.76,5.46,5.46,0,0,1,.46.86,5.22,5.22,0,0,1,.28.93,4.66,4.66,0,0,1,.1,1,4.59,4.59,0,0,1-.1,1,5.32,5.32,0,0,1-.28.94,5.46,5.46,0,0,1-.46.86,4.86,4.86,0,0,1-1.38,1.38,4.51,4.51,0,0,1-.87.46,5,5,0,0,1-.93.29A5.33,5.33,0,0,1,982.88,142.69Z"/>
          <path class="eb04f35d-97df-4bf3-837a-6350c5a8af27"
                d="M960.87,142.69H808.76a5,5,0,0,1,0-10H960.87a5,5,0,0,1,0,10Z"/>
          <path class="eb04f35d-97df-4bf3-837a-6350c5a8af27" d="M361.35,162.68h-69a5,5,0,0,1,0-10h69a5,5,0,0,1,0,10Z"/>
          <path class="eb04f35d-97df-4bf3-837a-6350c5a8af27"
                d="M830.28,449.94H804.94a5,5,0,0,1,0-10h25.34a5,5,0,0,1,0,10Z"/>
          <path class="eb04f35d-97df-4bf3-837a-6350c5a8af27"
                d="M688.56,47.73H617a5,5,0,0,1,0-10h71.59a5,5,0,0,1,0,10Z"/>
          <path class="eb04f35d-97df-4bf3-837a-6350c5a8af27"
                d="M335.28,285.37H206.67a5,5,0,1,1,0-10H335.28a5,5,0,0,1,0,10Z"/>
          <path class="eb04f35d-97df-4bf3-837a-6350c5a8af27" d="M817.61,513.59h-97a5,5,0,1,1,0-10h97a5,5,0,0,1,0,10Z"/>
          <path class="eb04f35d-97df-4bf3-837a-6350c5a8af27"
                d="M1020.77,238H883.33a5,5,0,0,1,0-10h137.44a5,5,0,0,1,0,10Z"/>
          <path class="eb04f35d-97df-4bf3-837a-6350c5a8af27"
                d="M266.62,162.68H265.2a5,5,0,0,1,0-10h1.42a5,5,0,0,1,0,10Z"/>
          <path class="eb04f35d-97df-4bf3-837a-6350c5a8af27"
                d="M345.15,318.35H266.54a5,5,0,0,1,0-10h78.61a5,5,0,0,1,0,10Z"/>
          <path class="eb04f35d-97df-4bf3-837a-6350c5a8af27"
                d="M277.19,460.46a5.33,5.33,0,0,1-1-.09,5,5,0,0,1-.93-.29,4.51,4.51,0,0,1-.87-.46,4.86,4.86,0,0,1-1.38-1.38,5.46,5.46,0,0,1-.46-.86,5.32,5.32,0,0,1-.28-.94,4.59,4.59,0,0,1-.1-1,5,5,0,0,1,2.22-4.15,4.51,4.51,0,0,1,.87-.46,4.88,4.88,0,0,1,2.89-.29,5.26,5.26,0,0,1,.93.29,4.74,4.74,0,0,1,.86.46,4.57,4.57,0,0,1,.76.62,5,5,0,0,1,1.47,3.53,5.34,5.34,0,0,1-.1,1,5.11,5.11,0,0,1-.29.94,4.69,4.69,0,0,1-.45.86,5.78,5.78,0,0,1-.63.76,4.57,4.57,0,0,1-.76.62,4.74,4.74,0,0,1-.86.46,5.26,5.26,0,0,1-.93.29A5.5,5.5,0,0,1,277.19,460.46Z"/>
          <path class="eb04f35d-97df-4bf3-837a-6350c5a8af27"
                d="M256.53,460.46H215.22a5,5,0,1,1,0-10h41.31a5,5,0,0,1,0,10Z"/>
          <path class="af60313a-2991-4142-84cb-e9f5a8c77182"
                d="M657.6,528.71h-13a4,4,0,1,1,0-8h9V503.57a4,4,0,0,1,8,0v21.14A4,4,0,0,1,657.6,528.71Z"/>
          <path class="af60313a-2991-4142-84cb-e9f5a8c77182"
                d="M619.43,528.71H594.26a4,4,0,0,1,0-8h25.17a4,4,0,0,1,0,8Zm-50.33,0H543.93a4,4,0,1,1,0-8H569.1a4,4,0,0,1,0,8Zm-50.34,0H493.59a4,4,0,1,1,0-8h25.17a4,4,0,0,1,0,8Zm-50.34,0H443.25a4,4,0,0,1,0-8h25.17a4,4,0,1,1,0,8Zm-50.34,0H408.9a24.87,24.87,0,0,1-17.24-6.89,4,4,0,1,1,5.52-5.79,16.93,16.93,0,0,0,11.72,4.68h9.18a4,4,0,0,1,0,8Zm-30.19-29.14a4,4,0,0,1-4-4V470.4a4,4,0,0,1,8,0v25.17A4,4,0,0,1,387.89,499.57Zm0-50.34a4,4,0,0,1-4-4V420.06a4,4,0,0,1,8,0v25.17A4,4,0,0,1,387.89,449.23Zm0-50.34a4,4,0,0,1-4-4V369.72a4,4,0,0,1,8,0v25.17A4,4,0,0,1,387.89,398.89Zm0-50.34a4,4,0,0,1-4-4V319.39a4,4,0,0,1,8,0v25.16A4,4,0,0,1,387.89,348.55Zm0-50.33a4,4,0,0,1-4-4V269.05a4,4,0,0,1,8,0v25.17A4,4,0,0,1,387.89,298.22Zm0-50.34a4,4,0,0,1-4-4V218.71a4,4,0,0,1,8,0v25.17A4,4,0,0,1,387.89,247.88Z"/>
          <path class="af60313a-2991-4142-84cb-e9f5a8c77182"
                d="M387.89,197.52a4,4,0,0,1-4-4v-13a4,4,0,0,1,4-4h19.7a4,4,0,0,1,0,8h-15.7v9A4,4,0,0,1,387.89,197.52Z"/>
          <rect class="a6d513f0-514b-4b61-8726-b21c3739a351" height="367.41" width="287.91" x="495.32" y="68.82"/>
          <path class="b8d212c2-8d6e-405d-9422-c9498cb7fe79"
                d="M762.22,444.23H711.54v-16h50.68a13,13,0,0,0,13-13V89.83a13,13,0,0,0-13-13H516.33a13,13,0,0,0-13,13V118.5h-16V89.83a29,29,0,0,1,29-29H762.22a29,29,0,0,1,29,29V415.22A29,29,0,0,1,762.22,444.23Z"/>
          <polygon class="a6d513f0-514b-4b61-8726-b21c3739a351"
                   points="711.54 485.91 423.63 485.91 423.63 118.5 628.36 118.5 711.54 200.29 711.54 485.91"/>
          <path class="eb04f35d-97df-4bf3-837a-6350c5a8af27"
                d="M690.53,493.91H444.65a29,29,0,0,1-29-29V139.51a29,29,0,0,1,29-29h183.7v16H444.65a13,13,0,0,0-13,13V464.9a13,13,0,0,0,13,13H690.53a13,13,0,0,0,13-13V200.29h16V464.9A29,29,0,0,1,690.53,493.91Z"/>
          <path class="a01e890d-37e4-4ddc-a93a-ca36d0e1d8c1"
                d="M711.54,208.29H628.35a8,8,0,0,1-8-8V118.5A8,8,0,0,1,634,112.79l83.19,81.8a8,8,0,0,1-5.61,13.7Zm-75.19-16H692l-55.65-54.71Z"/>
          <path class="af60313a-2991-4142-84cb-e9f5a8c77182"
                d="M417.4,56.72A16.65,16.65,0,0,1,415.89,64a18.68,18.68,0,0,1-3.5,5.12,48.89,48.89,0,0,1-4.74,4.16A28.62,28.62,0,0,0,403,77.69,5.25,5.25,0,0,0,402,81a6.52,6.52,0,0,1-2.32,5,7.62,7.62,0,0,1-10.07,0,6.63,6.63,0,0,1-2.22-5A18.93,18.93,0,0,1,389,72.92a20.88,20.88,0,0,1,3.76-5.63,51.54,51.54,0,0,1,5.1-4.58A28.17,28.17,0,0,0,402,59a2.69,2.69,0,0,0,.67-1.8c0-1.87,0-5.35-8.14-5.35a19.4,19.4,0,0,0-4.76.6A13.74,13.74,0,0,0,385.89,54a7.38,7.38,0,0,1-4,1.22,7.05,7.05,0,0,1-7-7,7.19,7.19,0,0,1,3.85-6.29,28.17,28.17,0,0,1,7.81-3.46,34.31,34.31,0,0,1,8.62-1c6.47,0,11.8,1.7,15.84,5.06A17.58,17.58,0,0,1,417.4,56.72Z"/>
          <path class="af60313a-2991-4142-84cb-e9f5a8c77182"
                d="M403.11,104.8a8.59,8.59,0,1,1-17.17,0,8.62,8.62,0,0,1,8.54-8.55,8.5,8.5,0,0,1,6.11,2.53A8.36,8.36,0,0,1,403.11,104.8Z"/>
          <rect class="af60313a-2991-4142-84cb-e9f5a8c77182" height="11.34" rx="5.67" width="196.92" x="469.13"
                y="321.2"/>
          <rect class="af60313a-2991-4142-84cb-e9f5a8c77182" height="11.34" rx="5.67" width="196.92" x="469.13"
                y="359.54"/>
          <rect class="af60313a-2991-4142-84cb-e9f5a8c77182" height="11.34" rx="5.67" width="196.92" x="469.13"
                y="285.52"/>
          <rect class="af60313a-2991-4142-84cb-e9f5a8c77182" height="11.34" rx="5.67" width="196.92" x="469.13"
                y="397.89"/>
          <rect class="af60313a-2991-4142-84cb-e9f5a8c77182" height="11.34" rx="5.67" width="196.92" x="469.13"
                y="436.23"/>
          <path class="af60313a-2991-4142-84cb-e9f5a8c77182"
                d="M523,213.41a5.55,5.55,0,0,1-4,1.65,5.49,5.49,0,0,1-4-1.65l-18.06-18.06-18.06,18.06a5.72,5.72,0,0,1-8.09-8.09l18.06-18-18.06-18a5.7,5.7,0,0,1,4-9.74,5.69,5.69,0,0,1,4,1.65l18.06,18,18.06-18a5.67,5.67,0,0,1,8,0,5.49,5.49,0,0,1,1.65,4,5.69,5.69,0,0,1-1.65,4.05l-18,18,18,18A5.75,5.75,0,0,1,523,213.41Z"/>
          <rect class="af60313a-2991-4142-84cb-e9f5a8c77182" height="28.14" transform="translate(-34.67 726.73) rotate(-45)" width="6.82" x="856.5"
                y="391.14"/>
          <rect class="af60313a-2991-4142-84cb-e9f5a8c77182" height="28.14" transform="translate(-22.12 731.93) rotate(-45)" width="6.82" x="869.04"
                y="378.59"/>
          <circle class="a9c882c5-5479-407f-8cba-3d90acfc6416" cx="806.38" cy="339.15" r="66.07"/>
          <path class="af60313a-2991-4142-84cb-e9f5a8c77182"
                d="M807.82,412.08a71.75,71.75,0,1,1,71.75-71.74A71.82,71.82,0,0,1,807.82,412.08Zm0-133.27a61.53,61.53,0,1,0,61.53,61.53A61.59,61.59,0,0,0,807.82,278.81Z"/>
          <path class="af60313a-2991-4142-84cb-e9f5a8c77182"
                d="M807.82,389.53a48.95,48.95,0,1,1,48.95-48.94A49,49,0,0,1,807.82,389.53Zm0-87.66a38.72,38.72,0,1,0,38.72,38.72A38.76,38.76,0,0,0,807.82,301.87Z"/>
          <path class="af60313a-2991-4142-84cb-e9f5a8c77182"
                d="M919.44,473.17A20.84,20.84,0,0,1,904.61,467l-38.56-38.56a11.94,11.94,0,0,1,0-16.87l12.78-12.78a11.93,11.93,0,0,1,16.87,0l38.56,38.56a21,21,0,0,1-14.82,35.79Zm-32.17-67.62a1.7,1.7,0,0,0-1.21.5l-12.78,12.78a1.71,1.71,0,0,0,0,2.41l38.56,38.56A10.74,10.74,0,1,0,927,444.61l-38.57-38.56A1.66,1.66,0,0,0,887.27,405.55Z"/>
        </g>
      </g>
    </svg>
  </section>
  <section class="app-empty-state__container__tittle">
    <h2>
      {{ tittle }}
    </h2>
  </section>
  <section class="app-empty-state__container__subTittle">
    {{ subTittle }}.
  </section>
</section>
